import api from './index'

const axios = require('axios')

export default {
    getCityDistricts: () => {
        const path = '/city-districts/all'

        return api.handling(axios.get(path))
    }
}
